// Explora Journeys Suites Information

export const suitesData = [
  {
    id: 'ocean-terrace',
    name: 'Ocean Terrace Suite',
    tagline: 'Spacious elegance with private terrace',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/azclqqdi_ocean%20terrace.webp',
    size: '377 sq ft (35 sqm)',
    terraceSize: '75 sq ft (7 sqm)',
    occupancy: '2 adults (some +1 child under 18)',
    features: [
      'Floor-to-ceiling windows with sweeping ocean views',
      'Private sun terrace with dining area and daybed',
      'Bespoke king-sized bed (convertible to twins)',
      'Walk-in wardrobe with seated vanity',
      'Spacious bathroom with walk-in shower',
      'Heated bathroom floors',
      'Refrigerated minibar replenished to preferences',
      'Espresso machine with biodegradable pods',
      'Mandala Blue custom bath amenities',
      'Dyson Supersonic™ hair dryer',
      'Complimentary high-speed Wi-Fi',
      'Pair of binoculars'
    ],
    services: [
      '24-hour in-suite dining',
      '24-hour concierge service',
      'Welcome champagne',
      'Personal refillable water bottles',
      'Shoeshine service',
      'Pillow menu'
    ]
  },
  {
    id: 'ocean-penthouse',
    name: 'Ocean Penthouse',
    tagline: 'Refined retreats with expansive terraces',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/dl57tau4_penthouse3.webp',
    size: '366-506 sq ft (34-47 sqm)',
    terraceSize: '97-226 sq ft (9-21 sqm)',
    occupancy: '2-4 adults',
    features: [
      'More generous interior spaces',
      'Expansive private terrace',
      'Enhanced furnishings and finishes',
      'Oversized floor-to-ceiling windows',
      'Separate living and sleeping areas',
      'Premium king-sized bed with luxury linens',
      'Walk-in wardrobe with vanity area',
      'Marble bathroom with walk-in shower or bathtub',
      'Heated bathroom floors',
      'Premium minibar selection',
      'Espresso machine and tea facilities',
      'Mandala Blue custom amenities',
      'Enhanced entertainment system'
    ],
    services: [
      'Priority embarkation',
      '24-hour in-suite dining',
      'Dedicated concierge service',
      'Welcome champagne and canapés',
      'Complimentary laundry services (select items)',
      'Priority restaurant reservations'
    ]
  },
  {
    id: 'ocean-residence',
    name: 'Ocean Residence',
    tagline: 'Spacious sanctuaries with butler service',
    image: 'https://customer-assets.emergentagent.com/job_bb879a25-df97-4746-b221-34f98bc25802/artifacts/711o0brk_image.png',
    size: '603-797 sq ft (56-74 sqm)',
    terraceSize: '151-807 sq ft (14-75 sqm)',
    occupancy: '2-4 adults',
    features: [
      'Among the largest suites at sea',
      'Private whirlpool on select residences',
      'Wraparound terraces on aft residences',
      'Separate living, dining, and sleeping zones',
      'Guest powder room',
      'Premium Molteni&C furniture',
      'Oversized dressing room',
      'Technogym Bench for personal fitness',
      'Two full bathrooms with luxury finishes',
      'Premium entertainment and sound system',
      'Office/work area',
      'Outdoor dining for 4-6 guests'
    ],
    services: [
      'Dedicated Residence Host (butler service)',
      'Priority embarkation and disembarkation',
      'Complimentary laundry and pressing',
      'In-suite breakfast service',
      'Afternoon tea service',
      'Evening canapés',
      'Priority shore excursion bookings',
      'Complimentary specialty restaurant dining'
    ]
  },
  {
    id: 'owners-residence',
    name: "Owner's Residence",
    tagline: 'The ultimate at-sea sanctuary',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/5g24j3h2_owners%20residence.webp',
    size: '1,668 sq ft (155 sqm)',
    terraceSize: '1,345 sq ft (125 sqm)',
    occupancy: '2 adults + 1 child under 2',
    features: [
      'Spans the full width of the ship aft',
      'Architectural masterpiece design',
      'Panoramic ocean views from every room',
      'Private whirlpool on expansive terrace',
      'Outdoor shower',
      'Multiple sun loungers and day beds',
      'Al fresco dining area for 8 guests',
      'Bespoke king-sized bed (200 x 200 cm)',
      'Oversized dressing room',
      'Master bathroom with dual vanities',
      'Separate living and dining areas',
      'Full entertainment system',
      'Private bar area'
    ],
    services: [
      'Dedicated Residence Manager',
      'Priority embarkation with private check-in',
      'Unlimited complimentary laundry and pressing',
      'Daily in-suite breakfast',
      'Afternoon tea and evening canapés',
      'Complimentary specialty dining (all restaurants)',
      'Personalized shore excursion planning',
      'Complimentary premium beverage package',
      'Private car transfers (select ports)'
    ]
  }
];

export const suiteCategories = [
  {
    title: 'Ocean Terrace Suite',
    subtitle: 'From 377 sq ft',
    link: 'ocean-terrace'
  },
  {
    title: 'Ocean Penthouse',
    subtitle: 'From 366 sq ft',
    link: 'ocean-penthouse'
  },
  {
    title: 'Ocean Residence',
    subtitle: 'From 603 sq ft',
    link: 'ocean-residence'
  },
  {
    title: "Owner's Residence",
    subtitle: '1,668 sq ft',
    link: 'owners-residence'
  }
];
